import { Box, Spinner, Text } from 'grommet';
import { useTranslation } from 'react-i18next';
import React from 'react';
import FieldDropdownV2 from './Dropdowns/FieldDropdownV2';
import PanelHeader from '../../common/PanelHeader';
import { useAppSelector } from '../../../../../redux';
import { getLatestUpdatedDate } from '../../../service/common/utils';

const RanchOverviewV2 = () => {
  const fields = useAppSelector((state) => state.map.fields);
  const latestUpdatedInfo = getLatestUpdatedDate(fields);

  const loading = useAppSelector((state) => state.map.loadingFields);
  const initialLoad = useAppSelector((state) => state.map.initialLoad);
  const { t } = useTranslation();

  if (loading || !initialLoad) {
    return (
      <Box height={'100%'} align={'center'} justify={'center'}>
        <Spinner color={'#FFE137'} size={'medium'} />
      </Box>
    );
  }

  return (
    <Box height={'100%'}>
      <Box direction={'row'} margin={'0 0 0 0'} justify={'between'} align={'center'} style={{ minHeight: '56px', minWidth: 'unset' }}>
        <Text weight={700} size={'1.5rem'} style={{ whiteSpace: 'nowrap' }}>
          {t('fieldFlow.mainWizard.Fields.title')}
        </Text>
        <PanelHeader />
      </Box>
      {latestUpdatedInfo?.updatedAt ? (
        <Text textAlign={'start'}>
          Updated by {latestUpdatedInfo?.updatedBy} at {latestUpdatedInfo?.updatedAt?.toLocaleDateString()}{' '}
          {latestUpdatedInfo?.updatedAt?.toLocaleTimeString()}
        </Text>
      ) : null}
      <Box height={'1px'} width={'100%'} background={'#808080'} margin={{ vertical: '16px' }} />
      <Box gap={'0.5rem'} overflow={'auto'}>
        {fields.map((field: any) => {
          return <FieldDropdownV2 key={field.id} field={field} />;
        })}
      </Box>
    </Box>
  );
};

export default RanchOverviewV2;
